import Box from "@mui/material/Box";
import Enums from "../General/Enums";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {modalButtonStyleDelete} from "../Jobs/TableTemplate";
import Modal from "@mui/material/Modal";
import * as React from "react";

const ConfirmDeleteDocumentModal = ({ showModal, closeModal, handleDeleteConfirmation }) => {
    return (
        <Modal data-testid={"confirmDelete-modal"}
               open={showModal}
               aria-labelledby="modal-modal-title"
               aria-describedby="modal-modal-description">
            <Box sx={Enums.modalStyle}>
                <h3>Delete document</h3>
                <Grid container direction={"row"} alignItems={"flex-end"} padding={2} spacing={2}>
                    <Grid item xs={12}>
                        <Typography>Are you sure you want to delete this document?</Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Button variant="outlined" onClick={closeModal} data-testid="cancel"
                                style={{
                                    float: 'right',
                                    width: '89px',
                                    height: '40px',
                                    fontFamily: 'Poppins',
                                    color: '#FF6600',
                                    borderColor: '#FF6600'
                                }}>Cancel
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button onClick={handleDeleteConfirmation} data-testid={"delete"} sx={modalButtonStyleDelete}>Delete</Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    )
};

export default ConfirmDeleteDocumentModal;